import get from 'lodash/get';
import { connect } from 'react-redux';
import { getCurrentUser, getPublicSession } from '../publicSession/selectors';
const mapStateToProps = (state)=>({
        userGuid: get(getCurrentUser(state), 'useridUuid'),
        biClientId: get(getPublicSession(state), 'biClientId'),
        biClientIdSigned: get(getPublicSession(state), 'biClientIdSigned')
    });
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=DealerAdIframe.container.js.map